import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from "react-router-dom";
import host from "../config";

const AccomodationImages = () => {
  const [ImagesList, setImagesList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  // let host = "http://localhost:3000";

  // Fetch data only once on component mount
  useEffect(() => {
    fetch(host + "/get-booking-images")
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, []); // Empty dependency array ensures it runs only once

  // Function to handle navigation
  const handleNavigate = (id) => {
    navigate(`/location/${encodeURIComponent(id)}`);
  };

  return (
    <div className="carousel-container">
      <Carousel
        showThumbs={false}
        autoPlay
        interval={3000} // Carousel speed (3 seconds)
        infiniteLoop
        selectedItem={currentIndex}
        onChange={(index) => setCurrentIndex(index)}
        showArrows={true} // Enable Next and Previous buttons
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <button
              type="button"
              className="carousel-button prev-button"
              onClick={onClickHandler}
            >
              ❮
            </button>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <button
              type="button"
              className="carousel-button next-button"
              onClick={onClickHandler}
            >
              ❯
            </button>
          )
        }
      >
        {ImagesList.map((item, idx) => (
          <div
            key={idx}
            className="image-wrapper"
            onClick={() => handleNavigate(item.location_id)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={item.url}
              alt={item.location}
              className="img-responsive img-rounded"
              style={{
                maxHeight: "400px",
                width: "100%",
                objectFit: "cover",
              }}
            />
            {/* <div className="location-name">{item.location}</div> */}
          </div>
        ))}
      </Carousel>

      <style jsx>{`
        .carousel-container {
          position: relative;
          width: 100%;
        }
        .image-wrapper {
          position: relative;
        }
        .location-name {
          position: absolute;
          top: 10px;
          right: 15px;
          background: rgba(0, 0, 0, 0.6);
          color: white;
          padding: 5px 10px;
          border-radius: 5px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
        }

        .carousel-button {
          position: absolute;
          bottom: 10px;
          background-color: rgba(75, 74, 74, 0.5);
          color: white;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: 0.3s ease-in-out;
          border: none;
          font-size: 20px;
          z-index: 10;
          top: 50%;
          transform: translateY(-50%);
        }

        .prev-button {
          left: 10px;
        }

        .next-button {
          right: 10px;
        }

        .carousel-button:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
      `}</style>
    </div>
  );
};
export default AccomodationImages;
